/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');

// window.Vue = require('vue');
window.Swal = require('sweetalert2');
window.$ = window.jQuery = require('jquery');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

$("input[type='password']").hideShowPassword({
    show: 'infer',
    innerToggle: true,
    // Options specific to the inner toggle.
    toggle: {
        // The element to create.
        element: '<button type="button">',
        // Class name of element.
        className: 'btn',
        verticalAlign: 'top',
    },
    states: {
        shown: {
            className: '',
            changeEvent: 'passwordShown',
            props: { type: 'text' },
            toggle: {
                className: '',
                content: '<i class="fas fa-eye-slash">',
                attr: {
                    'aria-pressed': 'true',
                    title: 'Скрыть пароль',
                }
            }
        },
        hidden: {
            className: '',
            changeEvent: 'passwordHidden',
            props: { type: 'password' },
            toggle: {
                className: '',
                content: '<i class="fas fa-eye">',
                attr: {
                    'aria-pressed': 'false',
                    title: 'Показать пароль',
                }
            }
        }
    }
});
